import React, { useEffect } from 'react';
import styled from 'styled-components';
// components
import Title from '../Title';

// assets
import BankLogo from '../../assets/img/BankLogo.png';
import Button from '../Button';
import useGAEventsTracker from '../../utils/useGAEventsTrackers';

const WrapperDiv = styled.div`
  height: 100%;
  width: 100%;
  padding: 2rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.background};
  text-align: center;
`;

const ImgDiv = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Img = styled.img`
  width: 100%;
`;



function CameraError() {
  const GAEventsTracker = useGAEventsTracker("Camera error");
  useEffect(() => {
    GAEventsTracker("Error al acceder a la camara");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRetry = () => {
    GAEventsTracker("Reintento");
    window.location.reload();
  };

  return (
    <WrapperDiv>
      <Title>
        Ha ocurrido un error al intentar acceder a la cámara, por favor revise su configuración de permisos.
        <br/>
        Apretá en el icono de candado que aparece arriba a la izquierda, toca en "Permisos" y "Restablecer permisos" para restablecer tus permisos.
      </Title>
      <ImgDiv>
        <Img src={BankLogo} />
      </ImgDiv>
      <Button filled onClick={handleRetry}>
        Reintentar
      </Button>
    </WrapperDiv>
  );
}

export default CameraError;